// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html.agc-cs-lock,
body.agc-cs-lock {
  overflow: hidden !important;
  overscroll-behavior: none !important;
  height: 100% !important;
}

.agc-cs {
  --gold: #c9a84c;
  --gold-light: #f5e5b0;
  --gold-mid: #e8c97a;
  --gold-dark: #8b6b2a;
  --bg: #08090c;
  --text: #f7f3ea;
  --mute: rgba(247, 243, 234, 0.7);
  --font: "Inter", "Segoe UI", system-ui, sans-serif;

  position: fixed;
  inset: 0;
  z-index: 1;
  display: grid;
  place-items: center;
  padding: 20px;
  overflow: hidden;
  overscroll-behavior: none;
  box-sizing: border-box;
  background: var(--bg);
  font-family: var(--font);
  color: var(--text);
  -webkit-font-smoothing: antialiased;
}

[data-theme="light"] .agc-cs,
body.light_theme .agc-cs {
  --bg: #090a0e;
}

.agc-cs__ambient {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.agc-cs__blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
}

.agc-cs__blob--1 {
  width: min(520px, 78vw);
  height: min(520px, 78vw);
  top: -18%;
  left: 50%;
  background: rgba(201, 168, 76, 0.32);
  animation: agc-cs-float-center 10s ease-in-out infinite;
}

.agc-cs__blob--2 {
  width: min(300px, 48vw);
  height: min(300px, 48vw);
  bottom: 0;
  left: -5%;
  background: rgba(139, 107, 42, 0.28);
  animation: agc-cs-float 12s ease-in-out infinite;
}

.agc-cs__blob--3 {
  width: min(260px, 42vw);
  height: min(260px, 42vw);
  bottom: 5%;
  right: -4%;
  background: rgba(232, 201, 122, 0.16);
  animation: agc-cs-float 11s ease-in-out infinite reverse;
}

.agc-cs__grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(201, 168, 76, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(201, 168, 76, 0.04) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(ellipse 70% 60% at 50% 45%, #000 10%, transparent 72%);
  opacity: 0.7;
}

.agc-cs__shell {
  position: relative;
  z-index: 1;
  width: min(520px, 100%);
  animation: agc-cs-up 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.agc-cs__shell::before {
  content: "";
  position: absolute;
  inset: -18px;
  border-radius: 36px;
  background: radial-gradient(ellipse at center, rgba(201, 168, 76, 0.22), transparent 68%);
  filter: blur(20px);
  z-index: -1;
  pointer-events: none;
}

.agc-cs__card {
  position: relative;
  overflow: hidden;
  padding: clamp(32px, 5vh, 48px) clamp(24px, 4.5vw, 40px) clamp(28px, 4.5vh, 42px);
  border-radius: 28px;
  border: 1px solid rgba(201, 168, 76, 0.28);
  background:
    linear-gradient(165deg, rgba(36, 34, 28, 0.95) 0%, rgba(16, 16, 20, 0.96) 55%, rgba(12, 12, 16, 0.98) 100%);
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.04) inset,
    0 30px 70px rgba(0, 0, 0, 0.55);
  text-align: center;
}

.agc-cs__shine {
  position: absolute;
  top: 0;
  left: -30%;
  width: 55%;
  height: 100%;
  background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.05), transparent);
  transform: skewX(-18deg);
  pointer-events: none;
  animation: agc-cs-shine 5.5s ease-in-out infinite;
}

.agc-cs__logo-link {
  display: inline-block;
  margin: 0 0 22px;
  text-decoration: none;
  transition: transform 0.25s ease;
}

.agc-cs__logo-link:hover {
  transform: scale(1.04);
}

.agc-cs__logo {
  display: block;
  width: min(250px, 64vw);
  height: auto;
  margin: 0 auto;
  filter: drop-shadow(0 10px 28px rgba(0, 0, 0, 0.4));
}

.agc-cs__title {
  margin: 0 0 14px;
  display: block;
  white-space: nowrap;
  font-size: clamp(2.5rem, 8vw, 3.6rem);
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 1.1;
  color: var(--text);
}

.agc-cs__title span {
  background: linear-gradient(130deg, #f5e5b0 0%, #e8c97a 28%, #c9a84c 58%, #8b6b2a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 8px 24px rgba(201, 168, 76, 0.25));
}

.agc-cs__text {
  margin: 0 auto 22px;
  max-width: 22rem;
  font-size: clamp(0.92rem, 2vw, 1.02rem);
  line-height: 1.6;
  color: var(--mute);
  font-weight: 500;
}

.agc-cs__loader {
  width: min(180px, 50vw);
  height: 3px;
  margin: 0 auto 26px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.agc-cs__loader-bar {
  display: block;
  width: 40%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, transparent, var(--gold-light), var(--gold), transparent);
  animation: agc-cs-loader 1.8s ease-in-out infinite;
}

.agc-cs__btns {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agc-cs__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 50px;
  border-radius: 999px;
  font-family: inherit;
  font-size: 0.94rem;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, border-color 0.2s ease;
  touch-action: manipulation;
}

.agc-cs__btn:hover {
  transform: translateY(-2px);
  text-decoration: none;
}

.agc-cs__btn i {
  font-size: 1.12rem;
}

.agc-cs__btn--main {
  background: linear-gradient(135deg, #f0d78a, #e8c97a 30%, #c9a84c 62%, #8b6b2a);
  color: #0a0a0e;
  box-shadow: 0 12px 30px rgba(201, 168, 76, 0.4);
}

.agc-cs__btn--main:hover {
  color: #0a0a0e;
  box-shadow: 0 16px 36px rgba(201, 168, 76, 0.52);
}

.agc-cs__btn--soft {
  border: 1px solid rgba(201, 168, 76, 0.42);
  background: rgba(201, 168, 76, 0.08);
  color: var(--text);
}

.agc-cs__btn--soft:hover {
  border-color: var(--gold-mid);
  background: rgba(201, 168, 76, 0.16);
  color: var(--text);
}

@keyframes agc-cs-up {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes agc-cs-float-center {
  0%,
  100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-18px);
  }
}

@keyframes agc-cs-float {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(12px, -14px);
  }
}

@keyframes agc-cs-loader {
  0% {
    transform: translateX(-120%);
  }
  100% {
    transform: translateX(280%);
  }
}

@keyframes agc-cs-shine {
  0%,
  55%,
  100% {
    left: -40%;
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  85% {
    left: 110%;
    opacity: 0;
  }
}

@media (min-width: 520px) {
  .agc-cs__btns {
    flex-direction: row;
  }

  .agc-cs__btn {
    flex: 1 1;
  }
}

@media (max-height: 680px) {
  .agc-cs__card {
    padding: 24px 20px 22px;
  }

  .agc-cs__logo {
    width: min(190px, 52vw);
  }

  .agc-cs__logo-link {
    margin-bottom: 14px;
  }

  .agc-cs__title {
    font-size: clamp(2rem, 7vw, 2.8rem);
    margin-bottom: 8px;
  }

  .agc-cs__text {
    font-size: 0.88rem;
    margin-bottom: 14px;
  }

  .agc-cs__loader {
    margin-bottom: 16px;
  }

  .agc-cs__btn {
    min-height: 44px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .agc-cs__blob,
  .agc-cs__shell,
  .agc-cs__loader-bar,
  .agc-cs__shine {
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ComingSoonPage/coming-soon.css"],"names":[],"mappings":"AAAA;;EAEE,2BAA2B;EAC3B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,kDAAkD;;EAElD,eAAe;EACf,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,SAAS;EACT,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,SAAS;EACT,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,UAAU;EACV,qCAAqC;EACrC,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;yEAEuE;EACvE,0BAA0B;EAC1B,kFAAkF;EAClF,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yFAAyF;EACzF,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iFAAiF;EACjF,mBAAmB;EACnB,0CAA0C;EAC1C;+GAC6G;EAC7G;;mCAEiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,wFAAwF;EACxF,wBAAwB;EACxB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uFAAuF;EACvF,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,4FAA4F;EAC5F,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mGAAmG;EACnG,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;EAC/E,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;;IAEE,yCAAyC;EAC3C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;;IAGE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;IACnC,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;AACF","sourcesContent":["html.agc-cs-lock,\nbody.agc-cs-lock {\n  overflow: hidden !important;\n  overscroll-behavior: none !important;\n  height: 100% !important;\n}\n\n.agc-cs {\n  --gold: #c9a84c;\n  --gold-light: #f5e5b0;\n  --gold-mid: #e8c97a;\n  --gold-dark: #8b6b2a;\n  --bg: #08090c;\n  --text: #f7f3ea;\n  --mute: rgba(247, 243, 234, 0.7);\n  --font: \"Inter\", \"Segoe UI\", system-ui, sans-serif;\n\n  position: fixed;\n  inset: 0;\n  z-index: 1;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  overflow: hidden;\n  overscroll-behavior: none;\n  box-sizing: border-box;\n  background: var(--bg);\n  font-family: var(--font);\n  color: var(--text);\n  -webkit-font-smoothing: antialiased;\n}\n\n[data-theme=\"light\"] .agc-cs,\nbody.light_theme .agc-cs {\n  --bg: #090a0e;\n}\n\n.agc-cs__ambient {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.agc-cs__blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(90px);\n}\n\n.agc-cs__blob--1 {\n  width: min(520px, 78vw);\n  height: min(520px, 78vw);\n  top: -18%;\n  left: 50%;\n  background: rgba(201, 168, 76, 0.32);\n  animation: agc-cs-float-center 10s ease-in-out infinite;\n}\n\n.agc-cs__blob--2 {\n  width: min(300px, 48vw);\n  height: min(300px, 48vw);\n  bottom: 0;\n  left: -5%;\n  background: rgba(139, 107, 42, 0.28);\n  animation: agc-cs-float 12s ease-in-out infinite;\n}\n\n.agc-cs__blob--3 {\n  width: min(260px, 42vw);\n  height: min(260px, 42vw);\n  bottom: 5%;\n  right: -4%;\n  background: rgba(232, 201, 122, 0.16);\n  animation: agc-cs-float 11s ease-in-out infinite reverse;\n}\n\n.agc-cs__grid {\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(201, 168, 76, 0.04) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(201, 168, 76, 0.04) 1px, transparent 1px);\n  background-size: 48px 48px;\n  mask-image: radial-gradient(ellipse 70% 60% at 50% 45%, #000 10%, transparent 72%);\n  opacity: 0.7;\n}\n\n.agc-cs__shell {\n  position: relative;\n  z-index: 1;\n  width: min(520px, 100%);\n  animation: agc-cs-up 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.agc-cs__shell::before {\n  content: \"\";\n  position: absolute;\n  inset: -18px;\n  border-radius: 36px;\n  background: radial-gradient(ellipse at center, rgba(201, 168, 76, 0.22), transparent 68%);\n  filter: blur(20px);\n  z-index: -1;\n  pointer-events: none;\n}\n\n.agc-cs__card {\n  position: relative;\n  overflow: hidden;\n  padding: clamp(32px, 5vh, 48px) clamp(24px, 4.5vw, 40px) clamp(28px, 4.5vh, 42px);\n  border-radius: 28px;\n  border: 1px solid rgba(201, 168, 76, 0.28);\n  background:\n    linear-gradient(165deg, rgba(36, 34, 28, 0.95) 0%, rgba(16, 16, 20, 0.96) 55%, rgba(12, 12, 16, 0.98) 100%);\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.04) inset,\n    0 30px 70px rgba(0, 0, 0, 0.55);\n  text-align: center;\n}\n\n.agc-cs__shine {\n  position: absolute;\n  top: 0;\n  left: -30%;\n  width: 55%;\n  height: 100%;\n  background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.05), transparent);\n  transform: skewX(-18deg);\n  pointer-events: none;\n  animation: agc-cs-shine 5.5s ease-in-out infinite;\n}\n\n.agc-cs__logo-link {\n  display: inline-block;\n  margin: 0 0 22px;\n  text-decoration: none;\n  transition: transform 0.25s ease;\n}\n\n.agc-cs__logo-link:hover {\n  transform: scale(1.04);\n}\n\n.agc-cs__logo {\n  display: block;\n  width: min(250px, 64vw);\n  height: auto;\n  margin: 0 auto;\n  filter: drop-shadow(0 10px 28px rgba(0, 0, 0, 0.4));\n}\n\n.agc-cs__title {\n  margin: 0 0 14px;\n  display: block;\n  white-space: nowrap;\n  font-size: clamp(2.5rem, 8vw, 3.6rem);\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  line-height: 1.1;\n  color: var(--text);\n}\n\n.agc-cs__title span {\n  background: linear-gradient(130deg, #f5e5b0 0%, #e8c97a 28%, #c9a84c 58%, #8b6b2a 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  filter: drop-shadow(0 8px 24px rgba(201, 168, 76, 0.25));\n}\n\n.agc-cs__text {\n  margin: 0 auto 22px;\n  max-width: 22rem;\n  font-size: clamp(0.92rem, 2vw, 1.02rem);\n  line-height: 1.6;\n  color: var(--mute);\n  font-weight: 500;\n}\n\n.agc-cs__loader {\n  width: min(180px, 50vw);\n  height: 3px;\n  margin: 0 auto 26px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  overflow: hidden;\n}\n\n.agc-cs__loader-bar {\n  display: block;\n  width: 40%;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, transparent, var(--gold-light), var(--gold), transparent);\n  animation: agc-cs-loader 1.8s ease-in-out infinite;\n}\n\n.agc-cs__btns {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.agc-cs__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 50px;\n  border-radius: 999px;\n  font-family: inherit;\n  font-size: 0.94rem;\n  font-weight: 700;\n  text-decoration: none;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, border-color 0.2s ease;\n  touch-action: manipulation;\n}\n\n.agc-cs__btn:hover {\n  transform: translateY(-2px);\n  text-decoration: none;\n}\n\n.agc-cs__btn i {\n  font-size: 1.12rem;\n}\n\n.agc-cs__btn--main {\n  background: linear-gradient(135deg, #f0d78a, #e8c97a 30%, #c9a84c 62%, #8b6b2a);\n  color: #0a0a0e;\n  box-shadow: 0 12px 30px rgba(201, 168, 76, 0.4);\n}\n\n.agc-cs__btn--main:hover {\n  color: #0a0a0e;\n  box-shadow: 0 16px 36px rgba(201, 168, 76, 0.52);\n}\n\n.agc-cs__btn--soft {\n  border: 1px solid rgba(201, 168, 76, 0.42);\n  background: rgba(201, 168, 76, 0.08);\n  color: var(--text);\n}\n\n.agc-cs__btn--soft:hover {\n  border-color: var(--gold-mid);\n  background: rgba(201, 168, 76, 0.16);\n  color: var(--text);\n}\n\n@keyframes agc-cs-up {\n  from {\n    opacity: 0;\n    transform: translateY(18px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes agc-cs-float-center {\n  0%,\n  100% {\n    transform: translateX(-50%) translateY(0);\n  }\n  50% {\n    transform: translateX(-50%) translateY(-18px);\n  }\n}\n\n@keyframes agc-cs-float {\n  0%,\n  100% {\n    transform: translate(0, 0);\n  }\n  50% {\n    transform: translate(12px, -14px);\n  }\n}\n\n@keyframes agc-cs-loader {\n  0% {\n    transform: translateX(-120%);\n  }\n  100% {\n    transform: translateX(280%);\n  }\n}\n\n@keyframes agc-cs-shine {\n  0%,\n  55%,\n  100% {\n    left: -40%;\n    opacity: 0;\n  }\n  60% {\n    opacity: 1;\n  }\n  85% {\n    left: 110%;\n    opacity: 0;\n  }\n}\n\n@media (min-width: 520px) {\n  .agc-cs__btns {\n    flex-direction: row;\n  }\n\n  .agc-cs__btn {\n    flex: 1;\n  }\n}\n\n@media (max-height: 680px) {\n  .agc-cs__card {\n    padding: 24px 20px 22px;\n  }\n\n  .agc-cs__logo {\n    width: min(190px, 52vw);\n  }\n\n  .agc-cs__logo-link {\n    margin-bottom: 14px;\n  }\n\n  .agc-cs__title {\n    font-size: clamp(2rem, 7vw, 2.8rem);\n    margin-bottom: 8px;\n  }\n\n  .agc-cs__text {\n    font-size: 0.88rem;\n    margin-bottom: 14px;\n  }\n\n  .agc-cs__loader {\n    margin-bottom: 16px;\n  }\n\n  .agc-cs__btn {\n    min-height: 44px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .agc-cs__blob,\n  .agc-cs__shell,\n  .agc-cs__loader-bar,\n  .agc-cs__shine {\n    animation: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
